/* eslint-disable no-shadow */
export enum FeatureFlags {
  THEME_TOGGLE = "themeToggle",
  SOLAR_PROPOSAL_V2 = "solarProposalV2",
  LEAD_WALLET = "leadWallet",
}
